import './styles/index.scss';
import 'react-toastify/dist/ReactToastify.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './features/auth/login';
import React, { useContext } from 'react';
import { AppContext, AppState } from './state/app-state';
import { Header } from './components/header/header';
import { useLocation } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { Channels } from './features/config';

const App = (): JSX.Element => {
  const location = useLocation();
  const appContext = useContext(AppContext) as AppState;

  if (appContext?.authenticated === undefined) {
    return <div>Loading...</div>;
  }

  if (!appContext?.authenticated) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  if (location.pathname === '/') {
    return <Navigate to="/channels" />;
  }

  return (
    <div>
      <Header />
      <div className="content">
        <ToastContainer />
        <Routes>
          <Route path="/channels/*" element={<Channels />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;
